import {
	NEWSPAPER_APPROVAL_START,
	NEWSPAPER_APPROVAL_SUCCESS,
	NEWSPAPER_APPROVAL_FAILURE,
	APPROVE_NEWSPAPER_START,
	APPROVE_NEWSPAPER_SUCCESS,
	APPROVE_NEWSPAPER_FAILURE,
	REJECT_NEWSPAPER_START,
	REJECT_NEWSPAPER_SUCCESS,
	REJECT_NEWSPAPER_FAILURE,
	DELETE_NEWSPAPER_START,
	DELETE_NEWSPAPER_SUCCESS,
	DELETE_NEWSPAPER_FAILURE,
	BULK_APPROVE_NEWSPAPER_START,
	BULK_APPROVE_NEWSPAPER_SUCCESS,
	BULK_APPROVE_NEWSPAPER_FAILURE,
	NewspaperResponse,
	NewspaperAction,
	CLEAR_NEWSPAPER_STATUS,
} from './NewspaperApproval.types';

// Get Newspaper Allowances
export const newspaperApprovalStart = (payload: any): NewspaperAction => ({
	type: NEWSPAPER_APPROVAL_START,
	payload,
});

export const newspaperApprovalSuccess = (response: NewspaperResponse): NewspaperAction => ({
	type: NEWSPAPER_APPROVAL_SUCCESS,
	payload: response,
});

export const newspaperApprovalFailure = (error: string): NewspaperAction => ({
	type: NEWSPAPER_APPROVAL_FAILURE,
	payload: error,
});

// Approve Newspaper Allowance
export const approveNewspaperStart = (payload: any): NewspaperAction => ({
	type: APPROVE_NEWSPAPER_START,
	payload,
});

export const approveNewspaperSuccess = (response: any): NewspaperAction => ({
	type: APPROVE_NEWSPAPER_SUCCESS,
	payload: response,
});

export const approveNewspaperFailure = (error: string): NewspaperAction => ({
	type: APPROVE_NEWSPAPER_FAILURE,
	payload: error,
});

// Reject Newspaper Allowance
export const rejectNewspaperStart = (payload: any): NewspaperAction => ({
	type: REJECT_NEWSPAPER_START,
	payload,
});

export const rejectNewspaperSuccess = (response: any): NewspaperAction => ({
	type: REJECT_NEWSPAPER_SUCCESS,
	payload: response,
});

export const rejectNewspaperFailure = (error: string): NewspaperAction => ({
	type: REJECT_NEWSPAPER_FAILURE,
	payload: error,
});

// Delete Newspaper Allowance
export const deleteNewspaperStart = (payload: any): NewspaperAction => ({
	type: DELETE_NEWSPAPER_START,
	payload,
});

export const deleteNewspaperSuccess = (response: any): NewspaperAction => ({
	type: DELETE_NEWSPAPER_SUCCESS,
	payload: response,
});

export const deleteNewspaperFailure = (error: string): NewspaperAction => ({
	type: DELETE_NEWSPAPER_FAILURE,
	payload: error,
});

// Bulk Approve Newspaper Allowances
export const bulkApproveNewspaperStart = (payload: any): NewspaperAction => ({
	type: BULK_APPROVE_NEWSPAPER_START,
	payload,
});

export const bulkApproveNewspaperSuccess = (response: any): NewspaperAction => ({
	type: BULK_APPROVE_NEWSPAPER_SUCCESS,
	payload: response,
});

export const bulkApproveNewspaperFailure = (error: string): NewspaperAction => ({
	type: BULK_APPROVE_NEWSPAPER_FAILURE,
	payload: error,
});

// Clear status (success/error) responses to avoid stale alerts
export const clearNewspaperStatus = (): NewspaperAction => ({
	type: CLEAR_NEWSPAPER_STATUS,
});
